document
	.querySelectorAll('.news-list__category .lottie-player')
	.forEach(clickDelay);

function clickDelay(item) {
	item.addEventListener('click', (event) => {
		event.preventDefault();
		item.setAttribute('direction', 1);
		item.setAttribute('autoplay', '');
		item.play();

		item.addEventListener('complete', () => {
			item.stop();
			item.seek(0);
			setTimeout(() => {
				window.location = item.getAttribute('href');
			}, 0);
		});
	});
}
